/**
 * scripts.js
 */
import $ from "jquery";
import Drupal from "Drupal";
import drupalSettings from "drupalSettings";
import {preventDefault} from "ol/events/Event";
import {display} from "@splidejs/splide/src/js/utils";


(function ($, Drupal, drupalSettings) {

  'use strict';

  Drupal.behaviors.saipem_disclaimer = {

     verify: function(element){
        if($(element).find('.disclaimer-checkbox:checked').length == $(element).find('.disclaimer-checkbox').length)
        {
               $('.document-disclaimer-confirm-link').show();
        }
        else
        {
             $('.document-disclaimer-confirm-link').hide();
        }
     },

     attach: function (context, settings) {
        once('press-disclaimer','#block-pressreleasedisclaimer',context).forEach(
          function (element) {
                $(element).find('.disclaimer-checkbox').click(function(){
                    Drupal.behaviors.saipem_disclaimer.verify(element);
                });

                if($.QueryString['verified'] == 1 && ( sessionStorage.getItem(window.location.pathname) == 'true') )
                {
                    $(element).hide();
                }

                $(element).find('.field--name-field-cancel-label').click(function(){
                    window.location.href = '/pr_listing'
                });
            }
        );

        once('document-disclaimer','.block-fixed-block-contentdisclaimer-document-media',context).forEach(

            function (element) {

                if($(element).closest('.media-row').find('.download-btn>.media-download-link'))
                {
                    var download_link = $(element).closest('.media-row').find('.download-btn>.media-download-link').attr('href');

                    $(element).find('.document-disclaimer-confirm-link').attr('href',download_link);

                    $(element).find('.document-disclaimer-confirm-link').click(function(){
                        $(element).hide();
                    });

                    $(element).closest('.media-row').find('.download-btn>.media-download-link').click(function(e){
                        e.preventDefault();
                        $(element).show();
                    })

                    $(element).find('.disclaimer-checkbox').click(function(){
                        Drupal.behaviors.saipem_disclaimer.verify(element);

                    });

                    $(element).find('.field--name-field-cancel-label').click(function(){
                        $(element).hide();
                    });
                }

                if($(element).closest('.saipem--card-content').find('.card-document-media-download-link'))
                {
                    var download_link = $(element).closest('.saipem--card-content').find('.card-document-media-download-link').attr('href');

                    $(element).find('.document-disclaimer-confirm-link').attr('href',download_link);

                    $(element).find('.document-disclaimer-confirm-link').click(function(){
                        $(element).hide();
                    });

                    $(element).closest('.saipem--card-content').find('.card-document-media-download-link').click(function(e){
                        e.preventDefault();
                        $(element).show();
                    })

                    $(element).find('.disclaimer-checkbox').click(function(){
                        Drupal.behaviors.saipem_disclaimer.verify(element);

                    });

                    $(element).find('.field--name-field-cancel-label').click(function(){
                        $(element).hide();
                    });
                }

            }
        );

       /**
        * $(element).find('.disclaimer-checkbox').click(function(){
        *                     Drupal.behaviors.saipem_disclaimer.verify(element);
        *                 });
        */

       $('.document-disclaimer-confirm-link').click(function(e){
          sessionStorage.setItem(window.location.pathname, true);
       });

       $('#block-landingdisclaimer').find('.disclaimer-checkbox').click(function(){
         Drupal.behaviors.saipem_disclaimer.verify('#block-landingdisclaimer');
       });

       if($.QueryString['verified'] == 1 && ( sessionStorage.getItem(window.location.pathname) == 'true' ))
       {
         $('#block-landingdisclaimer').hide();
       }

       $('#press-releases-disclaimer-wrapper').find('.disclaimer-checkbox').click(function(){
         Drupal.behaviors.saipem_disclaimer.verify('#press-releases-disclaimer-wrapper');
       });

       if($.QueryString['verified'] == 1 && ( sessionStorage.getItem(window.location.pathname) == 'true') )
       {
         $('#press-releases-disclaimer-wrapper').hide();
       }else{
         let releases = $('#press-releases-disclaimer-wrapper').siblings().hasClass('node--type-press-releases');
         if(releases){
           $('#press-releases-disclaimer-wrapper').siblings('.node--type-press-releases').hide();
         }
       }

       $('#landing-page-disclaimer-wrapper').find('.disclaimer-checkbox').click(function(){
         Drupal.behaviors.saipem_disclaimer.verify('#landing-page-disclaimer-wrapper');
       });

       if($.QueryString['verified'] == 1 && sessionStorage.getItem(window.location.pathname))
       {
         $('#landing-page-disclaimer-wrapper').hide();
       }else{
         let landingPageSection = $('#landing-page-disclaimer-wrapper').siblings().hasClass('node--type-landing-page');
         if(landingPageSection){
           $('#landing-page-disclaimer-wrapper').siblings('.node--type-landing-page').hide();
         }
       }



       $('#block-landingdisclaimer').find('.field--name-field-cancel-label').click(function(){
         //window.location.href = '/'
       });


  }
 }
 })(jQuery, Drupal, drupalSettings);


(function($) {
    $.QueryString = (function(a) {
        if (a == "") return {};
        var b = {};
        for (var i = 0; i < a.length; ++i)
        {
            var p=a[i].split('=');
            if (p.length != 2) continue;
            b[p[0]] = decodeURIComponent(p[1].replace(/\+/g, " "));
        }
        return b;
    })(window.location.search.substr(1).split('&'))
})(jQuery);
